document.addEventListener('DOMContentLoaded', () => {
  const buttonMenuOpen = document.getElementById('mobile-menu-open-button');
  const buttonMenuClose = document.getElementById('mobile-menu-close-button');
  const buttonSubmenuBack = document.querySelectorAll(
    '.mobile-menu-drawer__submenu-back-button'
  );

  const buttonSubmenuOpen = document.querySelectorAll(
    '.mobile-menu-drawer__submenu-button'
  );

  const mobileMenuDrawer = document.querySelector('.mobile-menu-drawer');

  const allSubmenus = document.querySelectorAll('.mobile-menu-drawer__submenu');

  buttonMenuOpen?.addEventListener('click', () => {
    document.body.classList.add('page-scroll-lock');
    if (mobileMenuDrawer) {
      mobileMenuDrawer.classList.add('mobile-menu-drawer--open');
    }
  });

  buttonMenuClose?.addEventListener('click', () => {
    document.body.classList.remove('page-scroll-lock');
    if (mobileMenuDrawer) {
      mobileMenuDrawer.classList.remove('mobile-menu-drawer--open');
    }

    allSubmenus.forEach((submenu) => {
      submenu.classList.remove('mobile-menu-drawer__submenu--open');
    });
  });

  buttonSubmenuOpen.forEach((button) => {
    button.addEventListener('click', () => {
      const submenu = button.nextElementSibling;
      if (submenu) {
        submenu.classList.toggle('mobile-menu-drawer__submenu--open');
      }
    });
  });

  buttonSubmenuBack.forEach((button) => {
    button.addEventListener('click', () => {
      const submenu = button.closest('.mobile-menu-drawer__submenu');
      if (submenu) {
        submenu.classList.remove('mobile-menu-drawer__submenu--open');
      }
    });
  });
});
